const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMglassFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M36 544v-2h1v1h16v-22H37v1h-1v-2h18v24H36Zm15-12a8.989 8.989 0 0 1-15.066 6.634l.081.081-6.3 6.3-.73-.73 6.3-6.3.08.081A9 9 0 1 1 51 532Zm-17 0a8 8 0 1 0 8-8 8 8 0 0 0-8 8Zm12-1h1l-2 6h-1l-2.579-9.456L39 534h-1l-2-5h1l1.484 3.709L41 526h1l2.55 9.35Z",
    transform: "translate(-29 -520)",
    style: {
      fill: "#26282d",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMglassFrame);
export default __webpack_public_path__ + "static/media/mglassFrame.90aef96e3132bdcd4213ba18cc606d0c.svg";
export { ForwardRef as ReactComponent };